module.exports = __webpack_public_path__ + "img/brand-fontawesome.c7d1a748.svg";